import axiosIns from '@/libs/axios'

export default {
  namespaced: true,
  state: {
    employeeTasks: [],
    employeeTasksCount: 0,
    employeeTask: {},
    employeeTaskSave: {
      message: null,
      status: null,
      id: null,
    },
  },
  getters: {
    getEmployeeTasks(state) {
      return state.employeeTasks
    },
    getEmployeeTasksCount(state) {
      return state.employeeTasksCount
    },
    getEmployeeTask(state) {
      return state.employeeTask
    },
    getEmployeeTaskSaveStatus(state) {
      return state.employeeTaskSave
    },
  },
  mutations: {
    EMPLOYEE_TASKS_LIST(state, data) {
      state.employeeTasks = data
    },
    EMPLOYEE_TASK_VIEW(state, data) {
      state.employeeTask = data
    },
    EMPLOYEE_TASKS_COUNT(state, data) {
      state.employeeTasksCount = data
    },
    EMPLOYEE_TASK_SAVE(state, data) {
      state.employeeTaskSave = data
    },
  },
  actions: {
    employeeTasksList({ commit }, params) {
      const data = JSON.stringify(params)
      axiosIns
        .post('/hrDefines/employee_tasks', data)
        .then(response => {
          commit('EMPLOYEE_TASKS_LIST', response.data.data)
          commit('EMPLOYEE_TASKS_COUNT', response.data.count)
        })
        .catch(error => console.error(error))
    },
    employeeTaskView({ commit }, id) {
      const data = JSON.stringify({
        where: {
          'employee_tasks.id': id,
        },
        array: false,
      })
      axiosIns
        .post('/hrDefines/employee_tasks', data)
        .then(response => {
          commit('EMPLOYEE_TASK_VIEW', response.data.data)
        })
        .catch(error => console.error(error))
    },
    employeeTasksSave({ commit }, postData) {
      const data = JSON.stringify(postData)
      axiosIns
        .post('/hrDefines/employee_tasks/saveData', data)
        .then(response => {
          commit('EMPLOYEE_TASK_SAVE', response.data)
        })
        .catch(error => console.error(error))
    },
  },
}
